import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=d15374fc&scoped=true&lang=scss"

import exportComponent from "/Users/kexikui/Desktop/code/dlmk/dlmk-news/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d15374fc"]])

export default __exports__